import styled from 'styled-components';

export const StyledAgentDetail = styled.div`
  width: 100%;
  color: var(--light-gray);
  .holder {
    padding: 10px 0 30px;
    font-size: 16px;
    line-height: 22px;
  }
  .head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 20px;
    .title {
      margin: 0;
    }
  }
  .img-box {
    width: 30px;
    img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }
  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    color: var(--text-color);
    margin: 0 0 10px;
  }
  .info-holder {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 0;
    margin: 0 0 15px;
    border-width: 1px 0;
    border-style: solid;
    border-color: #cdcdcd;
    .column {
      width: 50%;
      padding: 5px 0;
    }
    .text {
      display: block;
    }
  }
  .btn-holder {
    display: flex;
    gap: 10px;
  }
`;
